export const TRANSLATIONS_FR = {
    jobList: "Liste d'emplois",
    activeJobs: "No. d'emplois actifs",
    lang: "Langue",
    completedJobs: "Travaux terminés",
    totalRecordsIn: "Nombre d'enregistrements Dans",
    totalRecordsOut: "Nombre d'enregistrements Out",
    noCores: "Nombres de coeurs",
    tasks: "Tâches",
    heapUsage: "Utilisation Heap",
    results: "Résultats",
    cache: "cachette",
    notConnected: "Pas connecté",
    connected: "Lié",
    uploadedFiles: "fichiers téléchargés",
    restartBC: "Redémarrer BlueCardinal",
    addJob: "Ajouter le job",
    version: "Version",
    viewFullList: "Voir la liste complète",
    errors: "Les erreurs",
    currentLogs: "Journaux en cours",
    refresh: "Rafraîchir",
    cpuUsage: "L'utilisation du processeur",
    downloadFullLogs: "Télécharger Full Logs",
    viewAllLogs: "Voir tous les journaux",
    createNewOperator: "Créer un nouveau opérateur",
    toDashboard: "Dashboard",
    addExternalConfig: "Ajouter externe Config",
    submit: "Soumettre",
    logList: "Connexion Liste",
    toJobList: "À la liste d'emploi",
    download: "Télécharger",
    notifications: "Notifications",
    logout: "Se déconnecter",
    logSnippet: "Connexion Snippet",
    noLogs: "Journaux ne sont pas encore disponibles.",
    jobName: "Nom du travail",
    jobId: "ID de l'emploi",
    jobStatus: "Statut",
    jobStartTime: "Heure de début",
    jobRecordsIn: "Dans les dossiers",
    jobRecordsOut: "Out records",
    manageAcc: "Gérer son compte"
};
